import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button_VersionUpdate, LL_H_C, Button } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './AdvisorButton_VersionUpdate.scss';
export class AdvisorButton_VersionUpdate extends Button_VersionUpdate {
    getButtonToRender() {
        return _jsxs(LL_H_C, { className: 'content_version-update', children: [_jsxs(LL_H_C, { children: [_jsx(ICONS.advisor_v5_warning_exclamation_mark.component, {}), _jsxs("div", { className: 'version-details', children: ["Version ", this.getLatestVersion(), " Available"] })] }), _jsx(Button, { variant: 'primary', className: 'update-button', onClick: () => this.updateVersion(), children: "Update Now" })] });
    }
}
//# sourceMappingURL=AdvisorButton_VersionUpdate.js.map